/* Mouse Icon */
/**
 * Fügt ein Mouse Icon in den gewünschten Elementen hinzu und scrollt bei Klick darauf an eine bestimmte Position.
 * Die Scroll-Position wird im Standard automatisch so ermittelt, dass der Container vom elementSelector nicht mehr
 * sichtbar ist. Dazu einfach scrollTop nicht übergeben.
 *
 * Beispiele für die custom.js:
 *
 * mouseIcon('.slider_big,.slider_small');
 * mouseIcon('.slider_big,.slider_small',500);
 * mouseIcon('.slider_big,.slider_small', $(window).scrollTop() + 50);
 *
 * @param elementSelector
 * @param scrollTop Festen Wert, oder nicht übergeben
 */


function mouseIcon(elementSelector, scrollTop) {
    $(elementSelector).append('<div class="mouse-icon"><div class="wheel"></div></div>');
    $(elementSelector + ' .mouse-icon').click(function () {
        if (typeof scrollTop === 'undefined') {
            scrollTop = $(this).outerHeight() + $(this).offset().top - $(window).scrollTop();
        }
        $('html,body').animate({
            scrollTop: scrollTop
        }, 150);
        return false;
    });
}

